<template>
  <div class="home-bg">
    <van-nav-bar class="title" :title="$t('routerBase.'+$route.meta.title)" :left-arrow="false" fixed />
    <div class="content">
      <div v-for="(item, index) in itemList" :key="index" class="item-div" @click="goPage(item)">
        <div class="img-span">
          <img :src="item.icon">
          <span>{{ item.name }}</span>
        </div>
        <div class="arrow-div"><van-icon name="arrow" class="icon" /></div>
      </div>
      <van-button class="btn" @click="logout">{{ $t('viewBase.logout') }}</van-button>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  data() {
    return {
      /* {
        icon: require('@/assets/images/setting/user.png'),
          name: '我的家人',
        url: ''
      },*/
      itemList: [{
        icon: require('@/assets/images/setting/info.png'),
        name: this.$t('viewBase.basicinformation'),
        type: 'base',
        url: '/edit/user/set'
      }, /* {
        icon: require('@/assets/images/setting/set.png'),
        name: '设置',
        url: ''
      }, {
        icon: require('@/assets/images/setting/language.png'),
        name: '语言',
        url: ''
      }, */{
        icon: require('@/assets/images/setting/help.png'),
        name: this.$t('viewBase.instructions'),
        type: 'base',
        url: '/setting/doc'
      }, {
        icon: require('@/assets/images/setting/desc.png'),
        name: this.$t('viewBase.helpcenter'),
        type: 'base',
        url: '/setting/help'
      }, {
        icon: require('@/assets/images/setting/hide.png'),
        name: this.$t('viewBase.privacypolicy'),
        type: 'base',
        url: '/setting/privacy'
      }, {
        icon: require('@/assets/images/setting/about.png'),
        name: this.$t('viewBase.contactus'),
        type: 'phone',
        url: '010-80698974'
      }]
    }
  },
  mounted() {
  },
  methods: {
    goPage: function(item) {
      if (item.type === 'base') {
        this.$router.push(item.url)
      } else {
        Dialog.confirm({
          title: this.$t('viewBase.prompt'),
          message: this.$t('viewBase.promptcall')
        }).then(function() {
          window.location.href = 'tel://' + item.url
        })
      }
    },
    logout: function() {
      localStorage.clear()
      sessionStorage.clear()
      try {
        logout()
      } catch (err) {
        console.log(err)
      }
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped lang="scss">
  .btn {
    width: 92%;
    margin: 100px 4% 0;
    background: #F18937;
    color: #fff;
    border-radius:22px;
    font-size: 18px;
  }
  .home-bg{
    min-height: calc(100vh - 1rem);
    background-color: white;
  }
  .item-div{
    height: 55px;
    line-height: 55px;
    margin-left: 14px;
    border-bottom: solid 0.5px #E0E0E0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img-span{
      display: flex;
      align-items: center;
      span{
        margin-left: 11px;
        font-size:15px;
        font-family:PingFang SC;
        font-weight:200;
        color:rgba(51,51,51,1);
        line-height:15px;
      }
      img{
        width: 20px;
        height: 20px;
        line-height: 55px;
      }
    }
    .arrow-div{
      float: right;
      margin-right: 13px;
    }
  }
  .title{
    box-shadow:0px 3px 4px 0px rgba(190,190,190,0.3);
  }
  .content{
    padding-top: 0.92rem;
  }
</style>
